<template lang="pug">
  main
    ModalDelete(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:eliminar="deleteFactura")
    ModalInfo(v-show="modalStatus2" :title="titleModal2" :content="contentModal2" @padre:close="cerrarModal")
    NavBarFacturas
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Facturas TPA &nbsp
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns.is-vcentered
          .column.is-3-desktop.is-3-tablet
            b Seleccione una fecha:
            .field
              .control
                flat-pickr(
                  v-model='fecha_jornada'
                  :config="config"
                  class="input"
                )
        .columns
          .column.is-12.has-text-centered(v-show="hayDatos")
            .table-responsive
              table#tbFacturas.table.is-striped.is-fullwidth
                thead
                  tr
                    th #
                    th Embarque
                    th Fecha Facturación
                    th PDF
                    th Xml
                tbody
                  tr(v-for="(data, index) in facturas" :key="data.id")
                    td {{ index + 1 }}
                    td {{ data.embarque }} &nbsp
                      a.button.is-danger.is-small.is-rounded(@click="eliminarFactura(data.embarque)")
                        i.fas.fa-trash
                    td {{ data.fecha_fact }}
                    td(v-html="getlinkFact(data)")
                    td(v-html="getLinkXml(data)")
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos para ésta Búsqueda.
        .columns.column-blanco  
</template>

<script>
  import Loader from '../../shared/Loader.vue'
  import NavBarFacturas from '../layout/NavBarFacturas.vue'
  import facturasServices from '../../../services/facturas/facturas'
  import ModalDelete from '@/components/shared/ModalDelete.vue'
  import ModalInfo from '@/components/shared/ModalInfo.vue'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"

  export default {
    name: 'Facturas',
    components: { Loader, NavBarFacturas, ModalDelete, ModalInfo, flatPickr },
    data() {
      return {
        isLoading: true,
        fecha_jornada: moment().format('YYYY-MM-DD'),
        facturas: [],
        hayDatos: false,
        modalStatus: false,
        contentModal: '',
        titleModal: '',
        modalStatus2: false,
        contentModal2: '',
        titleModal2: '',
        embarqueSelected: '',
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        }
      }
    },
    watch: {
      fecha_jornada () {
        this.obtenerFacturas(this.fecha_jornada)
      }
    },
    methods: {
      inciarComponente() {
          this.obtenerFacturas(this.fecha_jornada)
      },
      obtenerFacturas(fecha) {
        facturasServices.getFacturas(fecha)
          .then(res => {
            console.log(res)
            this.isLoading = false
            this.facturas = res
            if (this.facturas.length > 0 ) {
              this.hayDatos = true
            } else {
              this.hayDatos = false
            }
            
          })
      },
      getlinkFact (fact) {
        var currentUrl = window.location.hostname
        let api_url = ''
        if (currentUrl === '10.121.50.145') {
          api_url = '10.121.50.130'
        } else {
          api_url = currentUrl
        }
        return `<a download="${fact.embarque}.pdf" class="button is-primary is-small" href="https://${api_url}/Facturas/${fact.ruta_Fact}" target="_blank">Descargar Factura</a>`
      },
      getLinkXml (fact) {
        var currentUrl = window.location.hostname
        let api_url = ''
        if (currentUrl === '10.121.50.145') {
          api_url = '10.121.50.130'
        } else {
          api_url = currentUrl
        }
        return `<a download="${fact.embarque}.xml" class="button is-success is-small" href="https://${api_url}/Facturas/${fact.ruta_Xml}" target="_blank">Descargar Xml</a>`
      },
      eliminarFactura (embarque) {
        this.embarqueSelected = embarque
        this.titleModal = `Eliminar Factura.`
        this.contentModal = `¿Desea Eliminar la Factura del embarque ${this.embarqueSelected}?`
        this.modalStatus = true
      },
      deleteFactura(result) {
        if (result === 'delete') {
          console.log('Eliminar Ip')
          this.isLoading = true
          facturasServices.deleteFactura(this.embarqueSelected)
            .then(data => {
              console.log(data)
              if (data.success){
                this.isLoading = false
                this.modalStatus = false
                this.titleModal2 = 'Factura Eliminada.'
                this.contentModal2 = `La Factura del embarque ${this.embarqueSelected} se ha Eliminado con Éxito.`
                this.modalStatus2 = true
                setTimeout(() => {
                  this.modalStatus2 = false
                  this.obtenerFacturas(this.fecha_jornada)                  
                }, 1000)
              } else {
                this.isLoading = false
                this.modalStatus = false
                this.titleModal2 = 'Error'
                this.contentModal2 = data.respuesta
                this.modalStatus2 = true
                setTimeout(() => {
                  this.modalStatus2 = false
                }, 1000)
              }
            })
          } else {
            console.log('Solo Cerrar')
            this.modalStatus = false
          }
      },
      cerrarModal () {
        this.modalStatus2 = false
      },
      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.inciarComponente()
    },

  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/grupos_Componentes/TPA/Facturas.vue